// Pricing-row tab: All / Free / Paid / Installed / Pinned. Labels
// live here (not in the Navbar's children map) so the Installed /
// Pinned tabs can append reactive counts — child-config `text` values
// would survive the merge as static strings, but this component's
// `text: (el, s) => …` runs reactively.

const LABELS = {
  all: 'All',
  free: 'Free',
  paid: 'Paid',
  installed: 'Installed',
  pinned: 'Pinned'
}

export const MarketplacePricingTab = {
  extends: 'Button',
  padding: 'Y A',
  borderRadius: 'Z',
  background: (el, s) => s.activePricing === el.key ? 'blue' : 'transparent',
  color: (el, s) => s.activePricing === el.key ? 'white' : 'caption',
  fontWeight: (el, s) => s.activePricing === el.key ? '600' : '400',
  text: (el, s) => {
    const base = LABELS[el.key] || el.key
    if (el.key === 'installed') {
      const n = s.installed?.length || 0
      return n > 0 ? `${base} (${n})` : base
    }
    if (el.key === 'pinned') {
      const n = s.pinnedIds?.length || 0
      return n > 0 ? `${base} (${n})` : base
    }
    return base
  },
  ':hover': { background: 'line' },

  onClick: (e, el, s) => s.update({ activePricing: el.key })
}
